import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=3d6e11cf&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=3d6e11cf&prod&lang=scss&scoped=true"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&id=3d6e11cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e11cf",
  null
  
)

export default component.exports